import { $authHost } from "../index";

export const sendAuthMailAPI = async (email: string, question: string) => {
    const { data } = await $authHost.post('/api/questions/send', { email, question })
    return data;
}